module.exports = __webpack_public_path__ + "static/kovka3-3b3b6a0f1e93b0919dd3878e1480339b.png";